import Clarity from "@microsoft/clarity";

declare global {
  interface Window {
    gtag?: (
      eventType: string,
      eventName: string,
      eventData?: Record<string, unknown>,
    ) => void;
  }
}

function gtag(
  eventType: string,
  eventName: string,
  eventData: Record<string, unknown> = {},
) {
  if (typeof window.gtag !== "function") {
    return false;
  }

  window.gtag(eventType, eventName, eventData);
  return true;
}

export function logEvent(
  eventName: string,
  eventData: Record<string, unknown> = {},
) {
  const sendTo = process.env.REACT_APP_ADS_EVENT_SENT_TO_ID;
  const eventDataConfig = sendTo
    ? {
        send_to: sendTo,
        value: 1.0,
        ...eventData,
      }
    : eventData;

  return gtag("event", eventName, eventDataConfig);
}

export function trackGoogleAdsLeadFormConversion(
  eventData: Record<string, unknown> = {},
) {
  const sendTo = process.env.REACT_APP_ADS_EVENT_SENT_TO_ID;

  if (!sendTo) {
    return false;
  }

  return gtag("event", "conversion", {
    send_to: sendTo,
    value: 1.0,
    ...eventData,
  });
}

export function initClarity() {
  const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;
  if (!projectId) {
    return;
  }
  try {
    Clarity.init(projectId);
  } catch (err) {
    // keep failures silent in production builds
    // eslint-disable-next-line no-console
    console.warn("Clarity init failed:", err);
  }
}

export function clarityIdentify(
  customId: string,
  customSessionId?: string,
  customPageId?: string,
  friendlyName?: string,
) {
  try {
    // @ts-ignore
    Clarity.identify(customId, customSessionId, customPageId, friendlyName);
  } catch (err) {
    // noop
  }
}

export function claritySetTag(key: string, value: string | string[]) {
  try {
    // @ts-ignore
    Clarity.setTag(key, value);
  } catch (err) {
    // noop
  }
}

export function clarityEvent(eventName: string) {
  try {
    // @ts-ignore
    Clarity.event(eventName);
  } catch (err) {
    // noop
  }
}

export function clarityConsentV2(options?: {
  ad_Storage: "granted" | "denied";
  analytics_Storage: "granted" | "denied";
}) {
  try {
    // @ts-ignore
    Clarity.consentV2(options);
  } catch (err) {
    // noop
  }
}

export function clarityConsent(consent?: boolean) {
  try {
    // @ts-ignore
    Clarity.consent(consent ?? true);
  } catch (err) {
    // noop
  }
}

export function clarityUpgrade(reason: string) {
  try {
    // @ts-ignore
    Clarity.upgrade(reason);
  } catch (err) {
    // noop
  }
}
